<header
  class="h-16 w-full max-w-full bg-white border-b border-gray-200 shadow-sm fixed top-0 left-0 right-0 z-50"
>
  <div
    class="flex items-center justify-between h-full gap-2 px-4 w-full max-w-full min-w-0 sm:px-6"
  >
    <div class="flex items-center gap-3">
      <app-environment-badge />
    </div>

    <div class="flex items-center gap-2 flex-shrink-0 sm:gap-4">
      <app-notificacao-badge></app-notificacao-badge>

      <app-user-menu></app-user-menu>
    </div>
  </div>
</header>
